import { all, takeLatest, put, call } from 'redux-saga/effects';

import i18n from '@dragonfruit/i18n';
import { apiResetUserEmail, apiVerifyEmail } from '../services/apis';
import { updateUserProfileInfo } from './profile';
import { NEW_USER } from '@dragonfruit/constants/emailVerifyStatus';

import {
  RESET_EMAIL,
  resetEmailSuccess,
  resetEmailFailure,
} from '../redux/resetEmail';
import { showAlertBanner } from '../redux/alertBanner';

import {
  ALERT_SUCCESS_THEME,
  ALERT_ERROR_THEME,
} from '../constants/alertBannerThemes';

export function* resetEmail(action) {
  yield i18n.loadNamespaces(['onboarding']);
  const { userId, email: newEmail } = action.payload;
  try {
    const { emailStatus } = yield call(apiVerifyEmail, newEmail);

    if (emailStatus !== NEW_USER) {
      throw { message: i18n.t('onboarding:onboarding.setUp.email.taken') };
    }

    const response = yield call(apiResetUserEmail, {
      userId,
      email: newEmail,
    });

    yield put(resetEmailSuccess());

    yield put(
      showAlertBanner({
        message: 'account.resetEmailSuccess',
        theme: ALERT_SUCCESS_THEME,
      })
    );

    yield call(updateUserProfileInfo, response);
  } catch (err) {
    yield put(resetEmailFailure(err.message));
    yield put(
      showAlertBanner({
        message: err.message,
        theme: ALERT_ERROR_THEME,
      })
    );
  }
}

export default function*() {
  yield all([takeLatest(RESET_EMAIL, resetEmail)]);
}



// WEBPACK FOOTER //
// ./app/sagas/resetEmail.js